import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {Address, AddressState}				from './interface';
import actions 								from './addressAction';


const initialState: AddressState = {
	isLoad:         false,
	isLoadPut:      false,
	data:           []
};

export const getAddressApi = createAsyncThunk('address/getAddressApi', actions.getAddressApi);
export const postAddressApi = createAsyncThunk('address/postAddressApi', actions.postAddressApi);
export const putAddressApi = createAsyncThunk('address/putAddressApi', actions.putAddressApi);
export const setMainAddressApi = createAsyncThunk('address/setMainAddressApi', actions.setMainAddressApi);
export const deleteAddressApi = createAsyncThunk('address/deleteAddressApi', actions.deleteAddressApi);


export const Reducer = createSlice({
	name:          'address',
	initialState,
	reducers:      {},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getAddressApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getAddressApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload || []
			});
		})
		// --- POST
		.addCase(postAddressApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(postAddressApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoad: false});

			const copy = [...state.data];
			copy.push(action.payload);

			return ({
				...state,
				data:   copy,
				isLoad: false
			});
		})
		// --- PUT
		.addCase(putAddressApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(putAddressApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoadPut: false});

			const copy: Address[] = state.data.map((address) => {
				if (address._id === action.payload._id)
					return ({...address, ...action.payload});
				return address;
			});

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		})
		.addCase(setMainAddressApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(setMainAddressApi.fulfilled, (state, action) => {
			if (!action.payload?.data?._id)
				return ({...state, isLoadPut: false});

			const copy: Address[] = state.data.map(address => (
				{...address, [action.payload.dataName]: address._id === action.payload.data._id}
			));

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		})
		// --- DELETE
		.addCase(deleteAddressApi.fulfilled, (state, action) => {
			const index = state.data.findIndex(find => find._id === action?.payload);
			const copy = [...state.data];

			if (index !== -1)
				copy.splice(index, 1);
			return ({...state, data: copy});
		});
	}
});

// export const {logout} = Reducer.actions;

export default Reducer.reducer;
